var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowPointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.449 304.476C314.918 313.82 305.98 319.992 295.996 319.992H190.976L236.125 414.81C245.621 434.751 237.156 458.615 217.217 468.116L217.216 468.116C197.271 477.619 173.398 469.151 163.899 449.203L117.282 351.298L42.281 439.545C37.64 445.014 30.906 447.998 24 447.998C21.218 447.998 18.422 447.514 15.719 446.529C6.281 443.061 0 434.06 0 423.997V55.98C0 46.542 5.531 37.979 14.125 34.104C22.75 30.26 32.828 31.76 39.874 37.979L311.871 277.99C319.355 284.6 321.98 295.147 318.449 304.476Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPointer);
export default __webpack_public_path__ + "static/media/arrow-pointer.9543695abcf4e242b45e627f3f52b906.svg";
export { ForwardRef as ReactComponent };